import { DatePicker } from '@mui/x-date-pickers'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'

/**
 * @description Renders a date field wrapped in a Controller component.
 *
 * @author Maria Eduarda Franke
 * @param {string} props.name - The name of the input field.
 * @param {string} props.label - The label for the input field.
 * @param {Object} props.control - The control object from react-hook-form.
 * @param {Object} props.errors - The errors object from react-hook-form.
 * @param {Object} props.textFieldProps - Additional props for the TextField component.
 * @returns {JSX.Element} - The rendered password input field.
 */
const FormInputDate = ({ name, label, control, errors, textFieldProps, ...props }) => {

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <DatePicker
                    {...field}
                    label={label}
                    slotProps={{
                        textField: {
                            error: !!errors,
                            helperText: errors?.message,
                            ...textFieldProps
                        }
                    }}
                    {...props}
                />
            )}
        />
    )
}

FormInputDate.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    control: PropTypes.object,
    errors: PropTypes.object,
    textFieldProps: PropTypes.object
}

export default FormInputDate